$(() => {
    const filterSection = $('.posts-filter-section, .team-posts-filter-section'),
        btnFilterExpand = filterSection.find('.filter-checkbox-group__expand');
        portfolioGeneralPost = $('.posts-general-section .post'),
        filterGroup = $('.filter-checkbox-group'),
        checkboxesGroup = $('.checkbox-group input'),
        portfoliotaxonomyPost = $('.posts-taxonomy-section .post'),
        searchInput = $('.search-group #quicksearch'),
        searchButton = $('.search-group button'),
        postfolioPage = $('.portfolio'),
        mobileExpand = $('.mobile-expand .close-btn'),
        navHeight = 40;

        //var from = history.back();
       // console.log(from);
//load content if cookie is available
     //alert(Cookies.get('company'));
   $('body').css('overflow', 'auto');
   if(Cookies.get('company') != null && Cookies.get('company') != 'undefined'){
       window.history.pushState('obj', 'newtitle', Cookies.get('company'));
    //   alert($(portfolioGeneralPost).children('div').attr('data-slug').find(Cookies.get('company')));
       //$(portfolioGeneralPost).find(`[data-slug='${Cookies.get('company')}']`).addClass('hms');
       $('.posts-content-holder-section').html($(portfolioGeneralPost).find(`[data-slug='${Cookies.get('company')}']`).find('.post__content-wrapper').clone());
       $('.posts-content-holder-section').addClass('active');
       $('body').css('overflow', 'hidden');
       setTimeout(() => {
           $('.posts-content-holder-section').find('.post__content-wrapper--inner').addClass('open');
       }, 300);
       
   }else{
        $('.posts-content-holder-section').find('.post__content-wrapper--inner').removeClass('open');
        $('.posts-content-holder-section').removeClass('active');
        $('body').css('overflow', 'auto');
       
       setTimeout(() => {
           $('.posts-content-holder-section .post__content-wrapper').remove();
       }, 150);
   }

   // load content popup
   $(portfolioGeneralPost).add(portfoliotaxonomyPost).on('click', '.post__wrapper', function () {

       //set cookie
       Cookies.set('company',  $(this).attr('data-slug'), { expires : 1, path : '/' });

       // url update
       window.history.pushState('obj', 'newtitle', $(this).attr('data-slug'));

       $('.posts-content-holder-section').html($(this).find('.post__content-wrapper').clone());
       $('.posts-content-holder-section').addClass('active');
       $('body').css('overflow', 'hidden');
       setTimeout(() => {

        let relatedPostsSectionInTeamInner = $('.posts-content-holder-section').find('.bs-section--team-inner-related-posts');
        if(relatedPostsSectionInTeamInner.length) {
          let pTag = relatedPostsSectionInTeamInner.find('> .container > .bs-row:nth-child(2) > .bs-column > p');
          if(pTag.html() == 'No articles found!') {
            relatedPostsSectionInTeamInner.hide();
          } else {
            relatedPostsSectionInTeamInner.show();
          }
        }
        
           $('.posts-content-holder-section').find('.post__content-wrapper--inner').addClass('open');
       }, 300);
   });

   // close content popup
   $(window).on('click', function (elem) {
       if (postfolioPage.length > 0) {
           if ($(elem.target).attr('class') == "post__content-wrapper--right" || $(elem.target).attr('class') == "post__content-wrapper--close") {
               $('.posts-content-holder-section').find('.post__content-wrapper--inner').removeClass('open');

               //remove cookie
               Cookies.remove('company');

               // url reset
               window.history.pushState('obj', 'newtitle', '/portfolio/');

               setTimeout(() => {
                   $('.posts-content-holder-section').removeClass('active');
                   $('body').css('overflow', 'auto');

                   setTimeout(() => {
                       $('.posts-content-holder-section .post__content-wrapper').remove();
                   }, 150);
               }, 300);
           }
       }
   });

    // Checkbox filter expand
    $(btnFilterExpand).on('click', function() {
        $(filterGroup).toggleClass('filter-checkbox-group--expand');
        $(btnFilterExpand).toggleClass('expanded');
        $('.filter-checkbox-group .mobile-expand').remove();
        $(filterSection).find('.filter-parent').removeClass('checkbox-group-close');
        if ($(window).width() < 568) {
            $(filterGroup).prepend($(btnFilterExpand).clone().append('<button class="close-btn"></button>').toggleClass('mobile-expand'));
        }
        if ($(window).scrollTop() < navHeight) {
            $('header').addClass('scrollMenu');
        }
    });

    $(searchInput).on('input', function (e) {
        if ($(searchInput).val() == '') {
            $(searchButton).hide();
        } else {
            $(searchButton).show();
        }
    });

    $(searchInput).focusin(
    function () {
        $(this).addClass('active');
    }).focusout(
    function () {
        $(this).removeClass('active');
    });

    $(filterSection).on('click', '.close-btn', function(){
        $('.filter-checkbox-group .mobile-expand').remove();
        $(btnFilterExpand).removeClass('expanded');
        $(filterSection).find('.filter-parent').addClass('checkbox-group-close');
        $(filterGroup).removeClass('filter-checkbox-group--expand');
        if ($(window).scrollTop() < navHeight) {
            $('header').removeClass('scrollMenu');
        }
    })

    // ------- Check box filter clear

    // Each Checkbox filter clear
    $('#selected-filters .selected-filters--sectors').add('#selected-filters .selected-filters--region').on('click', 'span', function () {
        let dataSlug = $(this).attr('data-checkslug');
        let dynamicCheckBox = $(`.posts-filter-section .checkbox-group input[data-checkslug="${dataSlug}"]`);
        $(dynamicCheckBox).click();
        // url reset
        window.history.pushState('obj', 'newtitle', '/portfolio/');
    });

    // All Checkbox filter clear
    $('#all-selected-filters--clear').on('click', () => {
        $(checkboxesGroup).each(function () {
            if ($(this).prop("checked") == true) {
                $(this).click();
            }
        });
        // url reset
        window.history.pushState('obj', 'newtitle', '/portfolio/');
    });

    // All sectors checkbox ckecked on click
    $('.posts-general-section .filter-button-group .view-mode__btn-view-all').on('click', () => {
        $('.checkbox-group input[data-or]').each(function () {
            if ($(this).prop("checked") == false) {
                $(this).click();
            }
        });
    });

    //filter from url
    $.urlParam = function(name){
        var results = new RegExp('[\?&]' + name + '=([^&#]*)').exec(window.location.href);
        if (results==null) {
           return null;
        }
        return decodeURI(results[1]) || 0;
    }
    // console.log($.urlParam('sector'));
    //     console.log($.urlParam('region'));
    //     console.log($.urlParam('status'));
    if($.urlParam('sector')){
        $(`.checkbox-group [data-checkslug='${$.urlParam('sector')}']`).click();
    }
    if($.urlParam('region')){
        $(`.checkbox-group [data-checkslug='${$.urlParam('region')}']`).click();
    }
    if($.urlParam('status')){
        $(`.checkbox-group [data-checkslug='${$.urlParam('status')}']`).click();
    }

    $(window).bind('resize', function() {
        $('.filter-checkbox-group .mobile-expand').remove();
    });
});